import { useNavigate, NavigateOptions, To } from 'react-router-dom';

interface NavigationType {
    type: 'backward' | 'forward';
}

interface NavigateFunction {
    (to: To, options: NavigateOptions & NavigationType): void;
    (delta: number, options: NavigationType): void;
}

function useNavigateWithTransition() {
    const nativeNavigate = useNavigate();

    const navigate: NavigateFunction = (to, options) => {
        const { type } = options;

        if (!type) return;

        if (!document.startViewTransition) {
            if (typeof to === 'number') {
                nativeNavigate(to);
            } else {
                nativeNavigate(to, options as NavigateOptions);
            }
            return;
        }

        if (type === 'forward') {
            document.documentElement.classList.remove('transition-backward');
            document.documentElement.classList.add('transition-forward');
        } else {
            document.documentElement.classList.remove('transition-forward');
            document.documentElement.classList.add('transition-backward');
        }

        document.startViewTransition(() => {
            if (typeof to === 'number') {
                nativeNavigate(to);
            } else {
                nativeNavigate(to, options as NavigateOptions);
            }
        });
    };

    return navigate;
}

export default useNavigateWithTransition;
